export default "__VITE_ASSET__257c67d3__"